var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import colors from '../utils/colors';
var customStyles = {
    option: function (provided, state) { return ({
        color: state.isDisabled ? colors.TP_GRAY : colors.TEXT_DEFAULT,
        padding: 8,
        '&:hover': {
            cursor: state.isDisabled ? 'default' : 'pointer',
        },
    }); },
    control: function (provided, state) { return (__assign(__assign({}, provided), { minWidth: '100%', minHeight: undefined, border: state.isFocused ? 0 : 0, 
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0, backgroundColor: undefined, '&:hover': {
            border: state.isFocused ? 0 : 2,
            borderColor: colors.TP_TURQUOISE,
        }, '&:focus': {
            border: 2,
            borderColor: colors.TP_TURQUOISE,
        } })); },
    indicatorSeparator: function () { return ({}); },
    indicatorsContainer: function () { return ({
        height: 'auto',
        paddingRight: 16,
        paddingLeft: 16,
    }); },
    dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { padding: 0 })); },
    placeholder: function (provided) { return (__assign(__assign({}, provided), { color: colors.GRAY, marginLeft: 0, marginRight: 0 })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { borderRadius: 0, marginTop: 2, boxShadow: '0 2px 20px 2px rgba(151,151,151,0.3)', '&:hover': {
            cursor: 'pointer',
        } })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { marginLeft: 0, marginRight: 0 })); },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { paddingLeft: 16 })); },
    input: function (provided) { return (__assign(__assign({}, provided), { fontSize: 12, margin: 0 })); },
};
var SelectWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    color: ", ";\n  }\n"], ["\n  svg {\n    color: ", ";\n  }\n"])), function (props) { return (props.isDisabled ? colors.TP_GRAY : props.theme.primaryColor || colors.BLUE); });
var BlueSelect = function (props) {
    var options = props.options, onChange = props.onChange, initValue = props.initValue;
    var defaultInitValue = {
        value: '-',
        label: '-',
        disabled: false,
    };
    var _a = useState(initValue || (options && options[0]) || defaultInitValue), value = _a[0], setValue = _a[1];
    var handleChange = function (e) {
        setValue(e);
        onChange(e);
    };
    return (React.createElement(SelectWrapper, { isDisabled: options === null },
        React.createElement(Select, { isDisabled: options === null, options: options, styles: customStyles, placeholder: null, onChange: handleChange, value: value, isOptionDisabled: function (option) { return option.disabled === true; } })));
};
export default BlueSelect;
var templateObject_1;
//# sourceMappingURL=BlueSelect.js.map